export const workshopCategories: {
  id: string;
  title: {
    ja: Workshop["category"];
    en: string;
  };
  intro: {
    ja: string;
    en: string;
  };
}[] = [
  {
    id: "section-0",
    title: {
      ja: "イベント",
      en: "Events",
    },
    intro: {
      ja:
        "zer◯では作品の創作過程や身体への向き合い方について多くの方に知っていただきたいという思いから、どなたでも気軽に参加いただけるワークショップを開催しております。ワークショップの情報については、Facebookやホームページ上のNewsにて配信しております。",
      en:
        "We offer participatory performances, workshops and workshops. Details of events you can attend are posted on our website and on our social networking site.",
    },
  },
  {
    id: "section-1",
    title: {
      ja: "教育支援活動",
      en: "Educational support",
    },
    intro: {
      ja:
        "zer◯では人と人とが身体を通してコミュニケーションを取ることを大切にしており、幼稚園・小中学校等の教育現場や地域の子どもたちに向けたワークショップを実施しております。ワークショップのご依頼は「Contact」に記載の宛先より承っております。",
      en:
        "We offer workshops at kindergartens and elementary and junior high schools to help students discover how to interact with people using their bodies.",
    },
  },
];
